// Models
import Model from './Model'

class CardOrder extends Model {
  get isCreated () {
    return this.status === CARD_ORDER_STATUSES.CREATED
  }

  get isDeclined () {
    return this.status === CARD_ORDER_STATUSES.DECLINED
  }

  get isRejected () {
    return this.status === CARD_ORDER_STATUSES.REJECTED
  }

  get isCompleted () {
    return this.status === CARD_ORDER_STATUSES.COMPLETED
  }

  get isInitialized () {
    return this.status === CARD_ORDER_STATUSES.INITIALIZED
  }

  get isInitializedRenew () {
    return this.status === CARD_ORDER_STATUSES.INITIALIZED_RENEW
  }

  get isForLegal () {
    return this.companyName != null
  }

  get isRealCardType () {
    return this.cardType === CARD_TYPES.REAL
  }

  get canBeSyncedStatus () {
    return [CARD_ORDER_STATUSES.REGISTERED, CARD_ORDER_STATUSES.PROCESSING, CARD_ORDER_STATUSES.COMPLETED]
      .some(status => status === this.status)
  }

  get holderName () {
    return `${this.holderFirstName} ${this.holderLastName}`
  }

  get recipientName () {
    return `${this.recipientFirstName} ${this.recipientLastName}`
  }

  get recipientAddress () {
    return [
      this.addressStreet,
      this.addressCity,
      this.addressZipCode,
      this.addressCountry
    ].join(', ')
  }

  static get statusOptions () {
    return [
      { name: 'Created', value: CARD_ORDER_STATUSES.CREATED },
      { name: 'Declined', value: CARD_ORDER_STATUSES.DECLINED },
      { name: 'Registered', value: CARD_ORDER_STATUSES.REGISTERED },
      { name: 'Processing', value: CARD_ORDER_STATUSES.PROCESSING },
      { name: 'Duplicate', value: CARD_ORDER_STATUSES.DUPLICATE_FOUND },
      { name: 'External check failed', value: CARD_ORDER_STATUSES.EXTERNAL_CHECK_FAILED },
      { name: 'Completed', value: CARD_ORDER_STATUSES.COMPLETED },
      { name: 'Rejected', value: CARD_ORDER_STATUSES.REJECTED },
      { name: 'Initialized', value: CARD_ORDER_STATUSES.INITIALIZED },
      { name: 'Initialized renew', value: CARD_ORDER_STATUSES.INITIALIZED_RENEW }
    ]
  }

  static get cardTypeOptions () {
    return [
      { name: 'Physical', value: CARD_TYPES.REAL },
      { name: 'Virtual', value: CARD_TYPES.VIRTUAL }
    ]
  }

  static get shipmentOptions () {
    return [
      { name: '5 — 20 working days (Post)', value: CARD_SHIPMENT_TYPES.STANDARD },
      { name: '3 — 10 working days (Courier)', value: CARD_SHIPMENT_TYPES.COURIER }
    ]
  }

  static get currencyOptions () {
    return CARD_CURRENCIES.map((currency) => ({ name: currency, value: currency }))
  }

  get schema () {
    return [
      'id',
      'dectaId',
      'accountId',
      'cardType',
      'currency',
      'status',
      'productCode',
      'supplementary',
      'ownerRelation',
      'holderType',
      'holderFirstName',
      'holderLastName',
      'holderMobilePhone',
      'holderEmail',
      'holderBirthDate',
      'holderDocuments',
      'companyName',
      'nameOnCard',
      'addressCountry',
      'addressCity',
      'addressStreet',
      'addressZipCode',
      'shipmentType',
      'recipientFirstName',
      'recipientLastName',
      'recipientMobilePhone',
      'profileId',
      'onboarderName',
      'reasonDeclined',
      'deliveryTrackingNumber',
      'createdAt',
      'updatedAt',
      'avsAddressCountry',
      'avsAddressCity',
      'avsAddressStreet',
      'avsAddressZipCode',
      'deliveryTrackingNumber',
      'feeAccountId',
      'feeCurrency',
      'actualShipmentType',
      'disableDeliveryFee',
      'userId'
    ]
  }
}

export const FULL_NAME_MAX_LENGTH = 22
export const COMPANY_NAME_MAX_LENGTH = 24

export const CARD_ORDER_STATUSES = {
  CREATED: 'CREATED',
  DECLINED: 'DECLINED',
  REGISTERED: 'REGISTERED',
  PROCESSING: 'PROCESSING',
  DUPLICATE_FOUND: 'DUPLICATE_FOUND',
  EXTERNAL_CHECK_FAILED: 'EXTERNAL_CHECK_FAILED',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  INITIALIZED: 'INITIALIZED',
  INITIALIZED_RENEW: 'INITIALIZED_RENEW'
}

export const CARD_TYPES = {
  REAL: 'REAL',
  VIRTUAL: 'VIRTUAL'
}

export const CARD_SHIPMENT_TYPES = {
  STANDARD: 'STANDARD',
  COURIER: 'COURIER'
}

export const CARD_HOLDER_TYPES = {
  OTHER: 'OTHER',
  OWNER: 'OWNER',
  RELATIVE: 'RELATIVE'
}

export const CARD_CURRENCIES = [
  'USD',
  'EUR',
  'GBP'
]

export default CardOrder
